import * as a from '../actions';
import DialogService from '../services/DialogService';

export const errorDialog = (payload) =>
  new Promise((resolve) =>
    DialogService.push({
      action: a.errorDialog(payload),
      resolve,
    }),
  );

export default errorDialog;



// WEBPACK FOOTER //
// ./src/common/components/dialog/helpers/errorDialog.js